/* eslint-disable import/no-anonymous-default-export */
export default {
  translations: {
    HOME: {
      INITIAL_PAGE: "Home Page",
      UPDATED_AT: "Updated at",
      QUICK_ACCESS: "Quick Access",
      SUPORT: "Suport",
      CALL_CENTER: "Call Center",
      VEHICLE_ASSISTANCE: "Vehicle Assistance:",
      DOES_NOT_HAVE: "dont have it yet?",
      CHAT_WITH_COMMERCIAL: "Meet and chat with our commercial.",
      GENERAL_DATA: "General Data",
      SEARCH: "Search",
      COMMERCIAL: "Commercial",
      LANGUAGE: "Language",
      VEHICLE_NOT_SELECTED: "No vehicle selected",
      QUICK_CONTACT: "Quick contact",
      CONTACT_REGIONAL: "Regional",
      CONTACT_COMERCIAL: "Commercial",
      CONTACT_CENTRAL: "Emergency Central 24h",
    },
    TITLE: {
      DASHBOARD: "Management dashboard",
      FILTERS: "Filters",
      FILTER_CHARTS: "Chart filters",
      FILTER_PERIODS: "Search period",
      FILTER_GROUPS: "Vehicle group",
      MY_FLEET: "My Fleet",
      MAP: "Map",
      MAIN_GRID: "Main dashboard (Grid)",
      DETAILED_POSITIONS: "Detailed Positions",
      DRIVERS_REGISTERED: "Registered Drivers",
      DRIVER_REGISTER: "Driver Registration",
      VEHICLES: "Vehicles",
      LOGS: "Logs",
      CLIENT_SEARCH: "Client Search",
    },
    MENU: {
      Home: "Home",
      Rastreamento: "Tracking",
      Grupos: "Groups",
      Controle: "Control",
      Atendimento: "Service",
      Relatórios: "Reports",
      Cadastro: "Register",
      Manutenção: "Maintenance",
      Sistema: "System",
    },
    DASHBOARD_CHARTS: {
      VEHICLE_STATUS: "Vehicle Status",
      DRIVER_RANKING: "Driver Ranking",
      GREATER_CIRCULATION: "Highest Circulation",
      GREATER_IDLENESS: "Highest Idleness",
      IDLENESS_DESCRIPTION_ENGINE: "Engine On",
      IDLENESS_DESCRIPTION_IDLE: "Stopped",
      IDLENESS_DESCRIPTION_OFF: "Engine Off",
      OUTSIDE_WORK_HOURS: "Outside Work Hours",
      OUTSIDE_WORK_HOURS_DESCRIPTION: "Outside Work Hours",
      INSIDE_WORK_HOURS_DESCRIPTION: "Inside Work Hours",
      WEEKLY_CIRCULATION: "Weekly Circulation",
      SPEED_LIMIT: "Speed Limit",
      TRANSIT_FINES: "Traffic Fines",
      SPEED_ABOVE_COMPANY_LIMIT: "Speed above company limit",
      SPEED_UP_TO_20_PERCENT_ABOVE: "Speed up to 20% above road limit (moderate violation)",
      SPEED_BETWEEN_20_50_PERCENT_ABOVE: "Speed between 20% and 50% above road limit (serious violation)",
      SPEED_ABOVE_50_PERCENT: "Speed above 50% of road limit (very serious violation)",
    },
    DASHBOARD: {
      ACTIVE_VEHICLES: "Active Vehicles",
      TOTAL_ODOMETER: "Total Odometer",
      WORK_HOURS_DISTANCE: "Work Hours Distance",
      OUTSIDE_WORK_HOURS_DISTANCE: "Outside Work Hours Distance",
      ENGINE_TIME: "Engine Time",
      IDLE_TIME: "Idle Time",
      OFF_TIME: "Off Time",
      SPEED_LIMIT_DISTANCE: "Positions with Speed Limit Exceeded",
      COMPANY_SPEED_LIMIT_DISTANCE: "Positions with Company Speed Limit Exceeded",
      TOTAL_FINES: "Total Fines",
    },
    TABLE_FINES: {
      DRIVER: "Driver",
      DATE: "Date",
      VALUE: "Value (US$)",
      PLATE: "Plate",
    },
    FLEET: {
      BACK: "Back",
      MAP: "Map",
      GRID_AND_MAP: "Grid + Map",
      ACTIONS: "Actions",
      VIEW_MAP: "View map",
      OPEN_GOOGLE_MAPS: "Open Google Maps",
      BLOCK: "Block",
      ANCHOR: "Anchor",
      COMMANDS: "Commands",
      CREATE_VISIT_POINT: "Create Visit Point",
      AVAILABLE_COMMANDS: "Available commands",
      COMMAND_SENT: "Command sent",
      VEHICLE: "Vehicle",
      THIS_VEHICLE_HAS_BLOCK: "This vehicle has block",
      COMMAND_HISTORY: "Command History",
      HISTORY: "History",
      NO_DATA_FOUND: "No data found for the selected period",
    },
    IGNITION: {
      ON: "On",
      OFF: "Off",
    },
    SEARCH: {
      SEARCH: "Search",
      INITIAL_DATE_TIME: "Initial date and time",
      FINAL_DATE_TIME: "Final date and time",
      UPDATE_PAGE: "Update page",
      UPDATE: "Update",
      INITIAL_TIME: "Initial Time",
      FINAL_TIME: "Final Time",
    },
    MAINTENANCE: {
      MAINTENANCE: "Maintenance",
      REGISTER: "Register",
      REMOVE: "Remove",
      REGISTER_MAINTENANCE: "Register Maintenance",
      REMOVE_MAINTENANCE: "Remove Maintenance",
    },
    COMMANDS: {
      SEND_COMMANDS: "Send Commands",
      COMMANDS: "Commands",
      COMMAND_HISTORY: "Command History",
      ANCHOR: "Anchor",
      BLOCK: "Block",
      UNLOCK: "Unlock",
    },
    REPORTS: {
      REPORT_REQUEST: "Report Request",
      NO_DATA_IN_RESPONSE: "The response does not contain the necessary data.",
      FILTER_VALIDATION: "Filter Validation",
      ERROR_FETCHING_REPORT: "Error fetching report data",
      SELECT_VEHICLE: "Select a vehicle",
      VEHICLE_ACTIVITY_TITLE: "Vehicle Activity Report",
    },
    REPORT_COLUMNS: {
      START: "Start",
      START_LOCATION: "Start Location",
      END: "End",
      END_LOCATION: "End Location",
      TOTAL_DISTANCE: "Total Distance",
      TRAVEL_TIME: "Travel Time",
      REST_TIME: "Rest Time",
      AVG_SPEED: "Average Speed",
      MAX_SPEED: "Maximum Speed",
      DRIVER: "Driver",
      PLATE: "Plate",
      DISTANCE: "Distance",
      DAY_OF_WEEK: "Day of Week",
      DATE: "Date",
      IGNITION_ON: "Ignition On",
      ENGINE_TIME: "Engine Time",
      SAMPLES_ABOVE_SPEED: "Samples above filtered speed",
      SAMPLES_WITHIN_SPEED: "Samples within filtered speed",
      DATE_TIME: "Date/Time",
      STATUS: "Status",
      IGNITION: "Ignition",
      EVENT: "Event",
      SPEED: "Speed",
      LOCATION: "Location",
      DURATION: "Duration",
      TYPE: "Type",
      PROTOCOL: "Protocol",
      DESCRIPTION: "Description",
      OPENING_DATE: "Opening Date",
      SERVICE_DATE: "Service Date",
      CLOSING_DATE: "Closing Date",
      ATTENDANT: "Attendant",
      ACCOUNT: "Account",
      USER: "User",
    },
    ERRORS: {
      FETCH_DATA_ERROR: "Error fetching data",
      FETCH_VEHICLES_STATUS_ERROR: "Error fetching vehicles status:",
      COMMAND_EXECUTION_ERROR: "Error executing command",
      FETCH_GROUPS_ERROR: "Error fetching groups:",
      CONFIG_NOT_FOUND: "There is no configuration for your domain. Send an email to <a href='mailto:contato@mirus.com.br'>contato@mirus.com.br</a>.",
      EMAIL_OR_PASS_INVALID: "Invalid credentials. Try again!",
      LOGIN_FAILED: "Could not log in. Check the data used.",
      EMAIL_FORMAT: "The email entered is not valid",
      CONFIRM_PASS: "Passwords must be the same",
      SEND_RECOVERY_MAILS: "Error sending password. Try again later.",
      USER_NOT_FOUND: "User not found",
      USER_NOT_SELECTED: "Select a login.",
      REQUIRED_FIELDS: "Fill in all fields",
      RESET_NOT_POSSIBLE: "Error trying to reset password, try again",
      KEY_PASS_INVALID: "Key not found, click the link received by email",
      SEARCH_ERROR: "Search error.",
      FETCH_DRIVER_LIST_ERROR: "Failed to fetch driver list",
      DELETE_DRIVER_ERROR: "Failed to delete driver",
      SAVE_DRIVER_ERROR: "Failed to save driver data",
      SAVE_LINK_ERROR: "Failed to save driver link",
      REMOVE_LINK_ERROR: "Failed to remove driver link",
    },
    COMMON: {
      CHART: "Chart",
      MIN: "Minimize",
      MAX: "Maximize",
      LOADING: "Loading",
      SEARCH: "Search",
      SAVE: "Save",
      CLOSE: "Close",
      BACK: "Back",
      ERROR: "Error",
      SUCCESS: "Success",
      ATTENTION: "Attention!",
      NAME: "Name",
      DOCUMENT: "Document",
      PLATE: "Plate",
      CPF_CNPJ: "CPF/CNPJ",
      ID: "ID",
      TYPE: "Type",
      DESCRIPTION: "Description",
      DATE: "Date",
      NO_DATA_FOUND: "No data found",
    },
    LOGIN: {
      LOADING_SETTINGS: "Loading settings...",
      CONTACTS: "Contacts",
      SOWING_FUTURE: "Sowing Future",
      LOGIN: "Login",
      USER: "User",
      PASSWORD: "Password",
      FORGOT_PASSWORD: "Forgot your password?",
      ACCESS: "Access",
      ACCESSING: "Accessing...",
      SELECT_ACCOUNT: "Select an account linked to the login",
      ACCOUNTS: "Accounts",
      BACK: "Back",
      NEW_PASSWORD: "New Password",
      CONFIRM_PASSWORD: "Confirm Password",
      RESET_PASSWORD: "Reset Password",
      RESETTING: "Resetting...",
      RESET: "Reset",
      PASSWORD_UPDATED_SUCCESS: "Password successfully updated",
      GO_TO_LOGIN_TEXT: "Click the button to go back to the beginning and log in with the new password",
      GO_TO_LOGIN: "Go to Login",
      PASSWORD_REMINDER: "Password Reminder",
      EMAIL: "Email",
      REMEMBER_PASSWORD: "Remember Password",
      SENDING: "Sending...",
      LOADING_TEXT: "Loading...",
    },
    DRIVER: {
      NAME: "Name",
      DOCUMENT: "Document",
      FUNCTIONAL_REGISTRY: "Functional Registry",
      RE: "RE",
      IBUTTON_KEY: "iButton Key",
      LICENSE_NUMBER: "License Number",
      LICENSE_CATEGORY: "License Category",
      CNH: "CNH",
      CNH_CATEGORY: "CNH Category",
      LICENSE_EXPIRATION: "License Expiration",
      EXPIRATION: "Expiration",
      BIRTH_DATE: "Birth Date",
      BIRTH: "Birth",
      MOBILE_PHONE: "Mobile Phone",
      CELL_PHONE: "Cell Phone",
      REGISTER: "Driver Registration",
      LINKED: "Linked",
      PLATE: "PLATE",
      IMPORT_SUCCESS: "Import successfully completed.",
    },
    CLIENT: {
      SEARCH_TITLE: "Client Search",
      FILL_FIELDS_TO_FILTER: "Fill in the fields to filter the search",
      SOCIAL_NAME: "Company Name",
      TRADE_NAME: "Trade Name",
      PLATE_NICKNAME: "Plate Nickname",
      CONTRACT_STATUS: "Contract Status",
    },
    LOGS: {
      OPERATION_TYPE: "Operation Type",
      SEARCH_BUTTON: "Search",
    },
    BUTTONS: {
      SAVE: "Save",
      CLOSE: "Close",
      CANCEL: "Cancel",
      DELETE: "Delete",
      SEARCH: "Search",
      BACK: "Back",
      UPDATE: "Update",
    },
    VEHICLE_NICKNAME: {
      TITLE: "Vehicle/Nickname",
      EDIT_NICKNAME: "Edit Nickname",
      PLATE: "Plate",
      NICKNAME: "Nickname",
      DELETE: "Delete",
      CANCEL: "Cancel",
      NICKNAME_OF_VEHICLE: "the vehicle nickname",
    },
    LINKED_VEHICLES: {
      TITLE: "Linked Vehicles",
      FILTER_BY_GROUP: "Filter by Group",
      ALL_GROUPS: "All groups",
      FILTER_BY_PLATE: "Filter by Plate",
      ALL_PLATES: "All plates",
      PLATE: "Plate",
      CURRENT_GROUP: "Current Group",
      SELECT_A_GROUP: "Select a group",
      CHANGED: "changed",
      NO_VEHICLES_FOUND: "No vehicles found",
      SAVE_CHANGES: "Save changes",
      CANCEL_CHANGES: "Cancel changes",
      NOTHING_TO_SAVE: "Nothing to save",
      NO_CHANGES_TO_SAVE: "No changes to save.",
      NO_RESPONSE: "No response",
      FAILURES: "Failures",
    },
    VIEW_MAP_FILTERS: {
      TITLE: "Radar",
      GROUPS: "Groups",
      ALL_GROUPS: "All groups",
      VEHICLES: "Vehicles",
      ALL_VEHICLES: "All vehicles",
      VIEW_VISITS: "View visits",
      OPEN_VISUALIZATION: "Open visualization",
      HELP_TEXT: "Select the filters and click Open visualization to open the map in full screen",
    },
    PROFILE: {
      TITLE: "Profile",
      USER_PROFILE: "User profile",
      PHONE: "Phone",
      NAME_REQUIRED: "Name is required.",
      EMAIL_REQUIRED: "Email is required.",
      PHONE_REQUIRED: "Phone is required.",
      PHONE_INVALID: "Invalid phone. Expected format: (XX) XXXX-XXXX or (XX) 9XXXX-XXXX.",
      UPDATING: "Updating...",
      UPDATED_SUCCESS: "Profile updated successfully!",
      UPDATE_ERROR: "An error occurred while trying to update the profile!",
      AVATAR_UPDATED: "Avatar updated, will be updated after logging in again",
    },
    DRIVER_PROFILE: {
      VEHICLES: "Vehicles",
    },
    LOGS_CONTROL: {
      ID: "Id",
      TYPE: "Type",
      DESCRIPTION: "Description",
      DATE: "Date",
    },
    GROUPS: {
      PAGE_TITLE: "Group Registration",
      LIST_TITLE: "Group List",
      REGISTER_TITLE: "Group Data",
      DELETE_ERROR_TITLE: "Error deleting",
      DELETE_ERROR_TEXT: "Group in use, deletion not allowed.",
      FILTERS: "Filters",
      SELECT_GROUP: "Select a group",
      CURRENT_GROUP: "Current Group",
      NO_VEHICLES_FOUND: "No vehicles found",
      ACTION_CONFIRMED: "Action confirmed!",
      CONFIRM: "Confirm",
      DESCRIPTION: "Description",
      DEFAULT: "Default",
      DEFINE_DEFAULT: "Define Default",
      DELETE: "Delete",
    },
    MODAL_VISITS: {
      TITLE: "Nearby Vehicles",
      GRID: "Grid",
      MAP: "Map",
      PLATE: "Plate",
      MODEL: "Model",
      DISTANCE: "Distance (m)",
      LAST_POSITION: "Last Position",
      EXPORT_PDF: "Export PDF",
      EXPORT_EXCEL: "Export Excel",
      NO_VEHICLES_NEARBY: "No nearby vehicles found",
    },
    VISIT_CONTROL: {
      TITLE: "Visit Control",
      NEW_VISIT: "New Visit",
      EDIT_VISIT: "Edit Visit",
      VISIT_NAME: "Visit Name",
      ADDRESS: "Address",
      RADIUS: "Radius (m)",
      CATEGORY: "Category",
      SAVE_SUCCESS: "Visit saved successfully",
      DELETE_SUCCESS: "Visit deleted successfully",
    },
    VISIT_POINTS: {
      TITLE: "Visit Points",
      POINT_NAME: "Point Name",
      COORDINATES: "Coordinates",
      CREATED_AT: "Created At",
    },
    REGISTER_VEHICLE: {
      TITLE: "Vehicle Registration",
      VEHICLE_DATA: "Vehicle Data",
      LICENSE_PLATE: "License Plate",
      CHASSIS: "Chassis",
      MODEL: "Model",
      YEAR: "Year",
      COLOR: "Color",
      SAVE_SUCCESS: "Vehicle saved successfully",
    },
    CONTROL_POINTS: {
      TITLE: "Control Points",
      NEW_POINT: "New Point",
      POINT_NAME: "Point Name",
      DESCRIPTION: "Description",
      TYPE: "Type",
    },
    VEHICLES_CONFIG: {
      TITLE: "Vehicle Configurations",
      GENERAL: "General",
      NOTIFICATIONS: "Notifications",
      SPEED_LIMIT: "Speed Limit",
      FUEL: "Fuel",
      MAINTENANCE: "Maintenance",
    },
    RISK_AREA: {
      TITLE: "Risk Areas",
      NEW_AREA: "New Area",
      AREA_NAME: "Area Name",
      DANGER_LEVEL: "Danger Level",
      LOW: "Low",
      MEDIUM: "Medium",
      HIGH: "High",
      CRITICAL: "Critical",
    },
    ELETRONIC_FENCES: {
      TITLE: "Electronic Fences",
      NEW_FENCE: "New Fence",
      FENCE_NAME: "Fence Name",
      FENCE_TYPE: "Fence Type",
      CIRCULAR: "Circular",
      POLYGONAL: "Polygonal",
      ACTIVE: "Active",
      INACTIVE: "Inactive",
      ALERT_ON_ENTRY: "Alert on Entry",
      ALERT_ON_EXIT: "Alert on Exit",
    },
    VEHICLE_NEAREST: {
      TITLE: "Nearest Vehicles",
      SEARCH_RADIUS: "Search Radius",
      FOUND_VEHICLES: "Found Vehicles",
      NO_VEHICLES: "No vehicles found in the area",
    },
    FILTERS_COMPONENT: {
      MINIMUM_DURATION: "Minimum Duration",
      TYPE: "Type",
      BOTH: "Both",
      VISIT_POINT: "Visit Point",
      STOP_POINT: "Stop Point",
      ALL: "All",
      COMPANY_SPEED_ONLY: "Company speed only",
      ROAD_SPEED_MODERATE: "Above road speed - moderate violation",
      ROAD_SPEED_SERIOUS: "Above road speed - serious violation",
      ROAD_SPEED_VERY_SERIOUS: "Above road speed - very serious violation",
      ROAD_SPEED_ALL: "Above road speed - all violations",
      VEHICLE: "Vehicle",
      ALL_VEHICLES: "All vehicles",
      DRIVERS: "Drivers",
      ALL_DRIVERS: "All drivers",
      START: "Start",
      END: "End",
      START_DATE_TIME: "Start date and time",
      END_DATE_TIME: "End date and time",
      REPORTS: "Reports",
      DISPLAY: "Display",
      EXCEL: "Excel",
      PDF: "PDF",
    },
    CLIENT_DETAILS: {
      PAGE_TITLE: "Client Details",
      VIEW_CLIENT: "View Client",
      FANTASY_NAME: "Fantasy Name",
      SHORT_NAME: "Short Name",
      FULL_NAME: "Full Name",
      SOCIAL_NAME: "Company Name",
      IDENTIFICATION: "Identification",
      ADDRESS: "Address",
      ADDRESS_2: "Address 2",
      COMPANY_REGISTRATION: "Company Registration",
      PHONE_1: "Phone 1",
      PHONE_2: "Phone 2",
      OBSERVATION: "Observation",
      NUMBER: "Number",
      NEIGHBORHOOD: "Neighborhood",
      COMPLEMENT: "Complement",
      STATE: "State",
      CITY: "City",
      ZIP_CODE: "ZIP Code",
      CNPJ: "CNPJ",
      STATE_REGISTRATION: "State Registration",
      MUNICIPAL_REGISTRATION: "Municipal Registration",
      SIMPLE_TAX_OPTANT: "Simple Tax Optant",
      PUBLIC_COMPANY: "Public Company",
      YES: "Yes",
      NO: "No",
    },
    TABLE: {
      DEFAULT: "Default",
      ACTIONS: "Actions",
      FILTER: "Filter",
      GLOBAL_SEARCH: "Global search",
      LOAD_DATA_ERROR: "Error loading data",
      SELECT_OPTION: "Select an option to display data.",
    },
    USER_NAV: {
      USER_PROFILE: "User Profile",
      CHANGE_PASSWORD: "Change Password",
      CLIENT_USERS: "Client Users",
      COMPANY: "Company",
      FILL_BOTH_FIELDS: "Fill both fields",
      PASSWORDS_MUST_MATCH: "Both passwords must match",
      PASSWORD_CHANGED: "Password changed",
      PASSWORD_CHANGED_SUCCESS: "Password changed successfully",
      PASSWORD_CHANGE_ERROR: "Error changing password, please try again later",
    },
    DELETE_MODAL: {
      CONFIRM_DELETE: "Do you really want to delete",
      OK: "Ok",
    },
    MESSAGE_MODAL: {
      WARNING: "Warning!",
    },
    INFO_WINDOW: {
      VEHICLE: "Vehicle",
      MODEL: "Model",
      MANUFACTURER: "Manufacturer",
      YEAR: "Year",
      CATEGORY: "Category",
      ADDRESS: "Address",
      STATUS: "Status",
      EVENT: "Event",
      DRIVER: "Driver",
      IGNITION_BATTERY: "Ignition (Battery)",
      GROUP: "Group",
      SPEED: "Speed",
      ODOMETER: "Odometer",
      TIME_ELAPSED: "Time Elapsed",
      TRACKER_BATTERY: "Tracker Battery",
      VEHICLE_BATTERY: "Vehicle Battery",
    },
    MAINTENANCES: {
      MAINTENANCE_ITEM: {
        DESCRIPTION: "Add the item you want to track usage of",
        INPUT_PLACEHOLDER: "Type the item name",
        BTN_SAVE: "Save New",
        BTN_CANCEL: "Cancel",
        FIELD_TABLE_ITEM: "Item",
        FIELD_TABLE_EDIT: "Edit",
        FIELD_TABLE_DELETE: "Delete",
      }
    },
    TOOLTIPS: {
      DASHBOARD:
        "Overview of all fleet data, including vehicle status, KPIs, and analysis charts.",
      // Dashboard - Cards KPI
      DASHBOARD_CARDS_ACTIVE_VEHICLES:
        "Indicates the number of tracked vehicles, according to the selected group filter.",
      DASHBOARD_CARDS_TOTAL_ODOMETER:
        "Indicates the sum of the odometers of tracked vehicles, according to the selected group and period filters.",
      DASHBOARD_CARDS_KM_BUSINESS_HOURS:
        "Indicates the sum of the odometers of tracked vehicles that circulated within business hours (default: Monday to Friday, 8 a.m. to 6 p.m.), according to the selected group and period filters.",
      DASHBOARD_CARDS_KM_OUTSIDE_HOURS:
        "Indicates the sum of the odometers of vehicles that circulated outside business hours (default: before 8 a.m. or after 6 p.m. on business days, any time on weekends), according to the selected group and period filters.",
      DASHBOARD_CARDS_ENGINE_TIME:
        "Indicates the sum of the time vehicles were on and moving, according to the selected group and period filters.",
      DASHBOARD_CARDS_IDLE_TIME:
        "Indicates the sum of the time vehicles were on but stopped (considered from 2 minutes in the same place), according to the selected group and period filters.",
      DASHBOARD_CARDS_OFF_TIME:
        "Indicates the sum of the time vehicles were turned off, according to the selected group and period filters.",
      DASHBOARD_CARDS_SPEED_LIMIT_DISTANCE:
        "Indicates the sum of the positions traveled above the legal road speed limit, according to the selected group and period filters.",
      DASHBOARD_CARDS_COMPANY_SPEED_LIMIT_DISTANCE:
        "Indicates the sum of the positions traveled above the speed defined by the company (urban default: 80 km/h, highway default: 120 km/h), according to the selected group and period filters.",

      // Dashboard - Charts
      DASHBOARD_CHARTS_VEHICLE_STATUS:
        "Shows the activity of fleet vehicles (on, off, stopped, moving) and highlights tracking issues such as GPS problems, positioning delays, and communication failures with the tracker.",
      DASHBOARD_CHARTS_QUICK_CONTACTS:
        "Provides quick access to Movyx contact options, including regional branch, Movyx consultant, and 24/7 call center.",
      DASHBOARD_CHARTS_DRIVERS_RANKING:
        "Driver or vehicle ranking that scores the driver/vehicle with the worst driving behavior, based on events and their weights. Useful to identify risky behavior in the fleet.",
      DASHBOARD_CHARTS_MOST_ACTIVE_VEHICLES:
        "Indicators that point out the vehicles with the highest circulation (vehicle on and moving). Useful metric to balance fleet usage and increase operational efficiency.",
      DASHBOARD_CHARTS_MOST_IDLE_VEHICLES:
        "Provides metrics about vehicles with the highest idleness (on but not moving). Useful for reducing operating costs, increasing efficiency, and planning maintenance.",
      DASHBOARD_CHARTS_OUTSIDE_HOURS_USAGE:
        "Indicates the use of vehicles outside the hours defined by the company (in km). Useful to identify improper use or exceptional situations in operations.",
      DASHBOARD_CHARTS_WEEKLY_CIRCULATION:
        "Indicator showing the sum of fleet circulation by period (in km), broken down by day of the week (Monday to Sunday).",
      DASHBOARD_CHARTS_SPEED_LIMIT_EXCESS:
        "Shows how much vehicles are exceeding speed limits, either the company limit or the legal road limit. Useful for safety management.",

      // Main pages
      MINHA_FROTA:
        "Check the real-time status of all vehicles in your fleet with detailed information on location and operation. View on map or grid with filters by plate, group, status, ignition, speed, driver, and location.",
      POSICOES_DETALHADAS:
        "Track the detailed position of each vehicle with movement history from the start of the day. Allows applying filters for other periods and performing specific actions.",
      GRID_JOURNEY_WORK:
        "Analyze vehicle work journeys with information on routes, durations, and operational efficiency. View trip details from origin to destination.",
      GRID_SPEED_CONTROL:
        "Monitor speeding events and speed above the limit, generating safety reports. Filter by vehicle grouping, type of occurrence, and analysis period.",
      GRID_VISIT_AMOUNT:
        "Track visit and stop points with analysis of time spent at each location. Identify which vehicles made visits with start, end, and duration of each one.",
      GRID_PERIOD_VISITS:
        "View visits grouped by period with performance statistics and metrics. Filter by minimum stay time and specific period.",
      GRID_PROTOCOLS:
        "Check protocols and procedures registered for each operational event, including automatic protocols, event-based protocols, or support protocols.",
      APELIDO:
        "Allows the user to assign a vehicle name, such as a fleet code or description.",
      RADAR:
        "Map view that automatically updates with all active vehicles, filtered by groups and periods. Opens in a separate browser window.",
      VEICULO_MAIS_PROXIMO:
        "Geolocation feature that lets you search for the vehicle closest to an address, another vehicle, or a visit point. Includes distance and estimated arrival time.",
      CONTROL_POINT:
        "Manage control and access points, monitoring passes and associated events. Allows registering locations where vehicles make stops and visits.",
      ELETRONIC_FENCES:
        "Configure and monitor electronic fences (geofences) for entry and exit alerts. Used for security, fleet control, and logistics management.",
      RISK_AREA:
        "Identify risk areas based on historical events and driving behavior. The system signals when vehicles enter or leave the delimited area.",
      VEHICLES_CONFIGURATION:
        "Configure vehicle properties and parameters, business hours, speed limits, and other references.",
      DRIVERS_MANAGEMENT:
        "Manage driver data, documents, event history, and performance. Add complementary data and define driving permissions per vehicle.",
      USERS_GROUPS:
        "Organize users into groups for access control and permissions. The main user can create and manage limited access for other users.",
      VEHICLES_GROUPS:
        "Group vehicles by operational criteria for easier analysis and management. Configure specific parameters, generate automatic reports, and define references.",
      VEHICLE_DETAILS:
        "Detailed vehicle information including technical specifications, documentation, history, and location. View battery level, ignition status, speed, odometer, and street view.",
      DRIVER_DETAILS:
        "Complete driver data, including licenses, event history, and performance. Add complementary information and driving permissions.",
      REPORTS:
        "Generate custom reports with data on operation, safety, and fleet efficiency, including movement, positioning, distance traveled, visits, and speed control.",
      SETTINGS:
        "Configure system preferences, notifications, and operating parameters. Change business hours, speed limits, and other fleet settings.",
      USER_PROFILE:
        "Manage your user profile, updating personal data and preferences. Also allows changing the password and managing account information.",
      HELP:
        "Help center with documentation, tutorials, and technical support. Access information about all system features.",
      POINT_OF_VISIT:
        "Register places where vehicles make stops and visits (suppliers, customers, points of interest). Helps identify locations when the address is replaced by the point name.",
      USER_PROFILE_CLIENT:
        "Define user information such as personal data and access preferences.",
      COMPANY_INFO:
        "Display registered company information, allowing data consultation.",
      CHANGE_PASSWORD:
        "Change your user account password for greater security.",
      PROTOCOLS:
        "Screen that allows consultation of generated protocols, whether automatic, event-based, or service-based.",
      LOGS:
        "Activity log screen that allows consulting all actions performed by the user in the Movyx Safe system.",
      GROUPS:
        "Screen to create, edit, and manage vehicle groups and their specific configuration, enabling automatic reports and configuration of parameters and references for reports and dashboards.",
      BIND_VEHICLES:
        "Allows assigning a vehicle to a group, and also reassigning vehicles from one group to another.",
      GROUP_USERS:
        "Manages user permissions (created within the customer account) to view and manage specific groups.",
      POSITION:
        "Function that allows accessing the vehicle positioning history for a specified period.",
      DISTANCE:
        "Query that determines the total distance traveled by a vehicle in a specific time interval, recording start and end points including their respective locations.",
      MAINTENANCE_ITEM: "Screen used to register and manage maintenance items, allowing users to create, edit, deactivate, and view all components that are part of the services",
      MAINTENANCE_SCHEDULING: "Screen intended for scheduling maintenance, where the user defines dates, vehicles or equipment, responsible persons, and the periodicity of the interventions that need to be carried out",
      MAINTENANCE_SHIPPING: "Screen focused on controlling the shipment and receipt of parts or equipment for external maintenance, recording shipments, carriers, deadlines, and the logistical status of each item",
      MAINTENANCE_REGISTER: "Screen responsible for the detailed registration of maintenance performed, including service description, parts used, hours worked, costs, and the technician responsible for execution",
      MAINTENANCE_PENDING: "Screen that lists all pending maintenance tasks, allowing users to filter, prioritize, and track activities that still need to be performed, approved, or scheduled in the maintenance workflow",
      MAINTENANCE_COMPLETED: "Screen that shows the history of completed maintenance, making it easier to perform queries, audits, and generate reports on performance, costs, and the history of equipment or vehicles",
    },
  },
};